export interface MarkButtonProps {
  selected?: boolean
}

export enum TopTiers {
  TextStyle,
  ListStyle,
  Link,
  TextColor,
  HighlightColor,
  TextAlign,
  Comments,
  None,
}
